"use strict";
/**
 * Login Page Handler
 * Binds the shared phone→code OTP flow (otp-login.ts) to the login page,
 * plus the hidden break-glass secret-key form (only revealed — and only
 * wired — when the app is opened with ?legacy=1, or from its button, which
 * only the recorder server shows).
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupLoginForm = setupLoginForm;
const otp_login_1 = require("./otp-login");
const auth_1 = require("../auth");
const network_error_1 = require("../api/network-error");
const server_kind_1 = require("../api/server-kind");
const ui_1 = require("../ui");
/**
 * Setup login form event listeners
 */
function setupLoginForm() {
    (0, otp_login_1.setupOtpLoginFlow)({
        form: "login-form",
        phoneStep: "login-step-phone",
        phoneInput: "phone-number",
        codeStep: "login-step-code",
        codeInput: "otp-code",
        submitButton: "login-submit",
        resendButton: "otp-resend",
        changeNumberButton: "otp-change-number",
        status: "otp-status",
        error: "login-error",
    });
    setupLegacyLoginForm();
}
/**
 * Break-glass secret-key login (server flag AUTH_LEGACY_SECRET_LOGIN).
 * Hidden AND inert unless the URL carries ?legacy=1 or, on the recorder
 * only, its button is tapped. The trading server never offers the button:
 * there the key logs in at level 99.
 */
function setupLegacyLoginForm() {
    const form = document.getElementById("legacy-login-form");
    if (!form)
        return;
    const params = new URLSearchParams(window.location.search);
    if (params.get("legacy") === "1") {
        revealLegacyForm(form);
        return;
    }
    void offerRecorderButton(form);
}
/** The recorder's only login is the key (no SMS there), so it gets a button. */
async function offerRecorderButton(form) {
    const button = document.getElementById("legacy-login-reveal");
    if (!button || !(await (0, server_kind_1.isRecorderServer)()))
        return;
    button.classList.remove("hidden");
    button.addEventListener("click", () => {
        button.classList.add("hidden");
        revealLegacyForm(form);
        document.getElementById("secret-key")?.focus();
    }, { once: true });
}
function revealLegacyForm(form) {
    form.classList.remove("hidden");
    form.addEventListener("submit", async (e) => {
        e.preventDefault();
        const secretKeyInput = document.getElementById("secret-key");
        const secretKey = secretKeyInput.value;
        // Check rate limit
        if ((0, auth_1.isRateLimited)()) {
            (0, ui_1.showError)("Too many failed attempts. Please try again later.", "legacy-login-error");
            return;
        }
        // Attempt authentication. A NetworkError means the request never
        // reached the server — that is not a failed attempt and must not count
        // against the lockout counter.
        let authenticated;
        try {
            authenticated = await (0, auth_1.authenticateWithSecretKey)(secretKey);
        }
        catch (error) {
            (0, ui_1.showError)((0, network_error_1.isNetworkError)(error)
                ? error.message
                : "Login failed. Please try again.", "legacy-login-error");
            return;
        }
        if (authenticated) {
            (0, ui_1.hideError)("legacy-login-error");
            secretKeyInput.value = ""; // Clear input for security
        }
        else {
            (0, auth_1.recordFailedAttempt)();
            (0, ui_1.showError)("Invalid secret key. Please try again.", "legacy-login-error");
        }
    });
}
